// extracted by mini-css-extract-plugin
export var linkText = "_nc-0";